<template lang="pug">
  .card-box.m-t-20
    h4.text-dark.header-title.m-b-10
      | 変換エラーが発生した画像
      span.badge.badge-danger.m-l-5
        | {{resources.length}}
    template(v-if="resources.length == 0")
      div 画像はすべてWebPに変換されました。変換エラーはありません。
    template(v-else)
      p WebPへの変換できなかった画像があります。
      table.table.table-bordered
        thead
          tr
            th(width="20%")
            th(width="40%") {{ 'orig' | i18nSimulation }}
        tbody
          tr
            th.text-xl 変換エラー画像の合計
            td
              div
                .text-xl.pull-left
                  Filesize(v-bind:value="sizes.orig")

          tr(v-for="(resource, idx) in resources")
            th
              div
                | 画像{{idx + 1}}
                = ' '
                ImageTypeBadge(v-bind:type="resource.ext")
              div
                small {{resource.hostname}}
            td
              .m-b-10
                a(v-bind:href="resource.url" target="_blank")
                  img.img-fluid(v-bind:src="resource.url")
                div
                  strong.pull-left
                    Filesize(v-bind:value="resource.data.orig.size")
</template>

<script>
import ResourcesTable from '@/components/ResourcesTable'

export default {
  mixins: [ResourcesTable],
}
</script>